import { IRole } from "core/types/base/IRole";
import React from "react";
import { Dropdown } from "react-bootstrap";
import Svg from "components/common/SVG/Svg";

type TProps = {
  onDelete: (id: string) => void;
  onEdit: (entity: IRole) => void;
  canUpsert: boolean;
  canRemove: boolean;
};

const RolesTableColumns = ({ onDelete, onEdit, canUpsert, canRemove }: TProps) => {
  return React.useMemo(() => {
    const columns: any[] = [
      {
        Header: "Name",
        accessor: "name",
        disableSortBy: true,
      },
    ];

    if (canUpsert || canRemove) {
      columns.push({
        Header: "Actions",
        accessor: "actions",
        disableSortBy: true,
        className: "text-end",
        width: 1,
        minWidth: 100,
        maxWidth: 120,
        Cell: ({ row: { original } }: any) => (
          <Dropdown>
            <Dropdown.Toggle
              className="no-caret btn btn-primary btn-sm"
              id={`dropdown-${original.id}`}
              aria-label="Actions"
            >
              <Svg icon="threeDots" width={20} height={20} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {canUpsert && (
                <Dropdown.Item onClick={() => onEdit(original)}>
                  <Svg icon="pencil" width={15} height={15} />
                  <span className="ms-2">Edit</span>
                </Dropdown.Item>
              )}
              {canRemove && (
                <Dropdown.Item onClick={() => onDelete(original.id)}>
                  <Svg icon="trash" width={15} height={15} />
                  <span className="ms-2">Delete</span>
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        ),
      });
    }

    return columns;
  }, [canRemove, canUpsert, onDelete, onEdit]);
};

export default RolesTableColumns;
